__turbopack_context__.v({
  "grid": "StoppedAgreementFeedback-module-scss-module__ln8sna__grid",
  "otherFeedback": "StoppedAgreementFeedback-module-scss-module__ln8sna__otherFeedback",
});
